import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFilterFieldsVariables = Types.Exact<{
  input: Types.FilterFieldsInput;
}>;

export type GetFilterFields = {
  filterFields: {
    pantherManaged: Array<
      Pick<Types.FilterField, 'target' | 'type' | 'description' | 'isPantherManaged' | 'logType'>
    >;
    filtersByLogType: Array<
      Pick<Types.GroupedFilterField, 'logType'> & {
        filters: Array<
          Pick<
            Types.FilterField,
            'target' | 'type' | 'description' | 'isPantherManaged' | 'logType'
          >
        >;
      }
    >;
    shared: Array<
      Pick<Types.FilterField, 'target' | 'type' | 'description' | 'isPantherManaged' | 'logType'>
    >;
  };
};

export const GetFilterFieldsDocument = gql`
  query GetFilterFields($input: FilterFieldsInput!) {
    filterFields(input: $input) {
      pantherManaged {
        target
        type
        description
        isPantherManaged
        logType
      }
      filtersByLogType {
        logType
        filters {
          target
          type
          description
          isPantherManaged
          logType
        }
      }
      shared {
        target
        type
        description
        isPantherManaged
        logType
      }
    }
  }
`;

/**
 * __useGetFilterFields__
 *
 * To run a query within a React component, call `useGetFilterFields` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterFields` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterFields({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFilterFields(
  baseOptions: Apollo.QueryHookOptions<GetFilterFields, GetFilterFieldsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFilterFields, GetFilterFieldsVariables>(
    GetFilterFieldsDocument,
    options,
  );
}
export function useGetFilterFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFilterFields, GetFilterFieldsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFilterFields, GetFilterFieldsVariables>(
    GetFilterFieldsDocument,
    options,
  );
}
export function useGetFilterFieldsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetFilterFields, GetFilterFieldsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFilterFields, GetFilterFieldsVariables>(
    GetFilterFieldsDocument,
    options,
  );
}
export type GetFilterFieldsHookResult = ReturnType<typeof useGetFilterFields>;
export type GetFilterFieldsLazyQueryHookResult = ReturnType<typeof useGetFilterFieldsLazyQuery>;
export type GetFilterFieldsSuspenseQueryHookResult = ReturnType<
  typeof useGetFilterFieldsSuspenseQuery
>;
export type GetFilterFieldsQueryResult = Apollo.QueryResult<
  GetFilterFields,
  GetFilterFieldsVariables
>;
export function mockGetFilterFields({
  data,
  variables,
  errors,
}: {
  data: GetFilterFields;
  variables?: GetFilterFieldsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetFilterFieldsDocument, variables },
    result: { data, errors },
  };
}
